import { GenericService } from "./Generic.service";

export class QuestionnaireService extends GenericService<string>{

    readonly URI: string = 'Questionario'

    constructor(){
        super()
        this.setUri(this.URI);
    }
//801bea09-a642-4711-a12a-a6d9e7930e28
    public async getQuestionario(id: string){
        return await super.getByResource(`${id}`, { id: id})
    }

}